// extracted by mini-css-extract-plugin
export default {"box":"SelectBankAccount_box__odleY","selected":"SelectBankAccount_selected__lLaLR","check":"SelectBankAccount_check__UQSzz"};